import React, { useEffect } from "react";
import "./AgenticAIBlog.css";
import { useLocation } from "react-router-dom";
import { blogContent } from "../../Data/BlogData";
import NavComponent from "../../components/NavComponent";
import SEOHelmet from "../../components/SEOHelmet";
import { blogJsonLd } from "../../Data/SEO-JsonData";

export const AgenticAIBlog = () => {
  const location = useLocation();
  const { state } = location;
  // const BlogDetails = blogContent.find((item, index) => item.id === state);
  const BlogDetails = blogContent[4];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="element">
      <SEOHelmet
        title="Agentic AI Automation for QA: Realistic ROI & Cost Savings | Canvendor"
        description="Learn how Agentic AI automation realistically reduces QA costs by 20–35%, accelerates testing, and improves coverage. A transparent look at what works—and what to consider before adopting."
        keywords="test automation, agentic AI, QA automation, self-healing tests"
        url="https://www.canvendor.com/blog/agentic-ai-automation-qa-realistic-roi"
        image="https://www.canvendor.com/BlogImages/blogBannerImage2.jpg"
        alt="Agentic AI Automation for QA: Realistic ROI & Cost Savings"
        jsonLd={blogJsonLd}
      />

      <NavComponent></NavComponent>
      <div className="container">
        {/* Header */}
        {/* <header className="header">
          <h1 className="main-title">{BlogDetails.title}</h1>
        </header> */}

        {/* Content Wrapper - Now includes hero image and sidebar */}
        {/* Left Column - Hero Image + Main Content */}
        <div className="main-column">
          {/* Hero Image */}
          <div className="blog-hero-image">
            <img src={BlogDetails?.image} alt="Healthcare AI Technology" />
          </div>

          {/* Main Article */}
          <main className="main-content">
            {/* TL;DR Section */}

            {BlogDetails.sections.map((con, index) => {
              return (
                <section key={index} className="section">
                  {con?.heading && (
                    <h2 className="section-title">
                      <span>{con?.heading || ""}</span>
                      <img
                        className="title-underline"
                        src="https://c.animaapp.com/memovagbcMSRxN/img/vector-1.svg"
                        alt=""
                      />
                    </h2>
                  )}
                  <p className="section-text">{con?.content || ""}</p>
                  <p className="section-text">{con?.content1 || ""}</p>
                  <p className="section-text">{con?.content2 || ""}</p>
                  <p className="section-text">
                    {con?.listHeading || ""}
                    <ul>
                      {con?.list?.map((item, index) => {
                        if (item.includes(":")) {
                          const [boldText, normalText] = item.split(":");
                          return (
                            <li key={index}>
                              <strong>{boldText}:</strong>
                              {normalText}
                            </li>
                          );
                        }
                        return <li key={index}>{item}</li>;
                      })}
                    </ul>
                  </p>
                  <p className="section-text">
                    {con?.listHeading1 || ""}
                    <ul>
                      {con?.list1?.map((item, index) => {
                        if (item.includes(":")) {
                          const [boldText, normalText] = item.split(":");
                          return (
                            <li key={index}>
                              <strong>{boldText}:</strong>
                              {normalText}
                            </li>
                          );
                        }
                        return <li key={index}>{item}</li>;
                      })}
                    </ul>
                  </p>
                  <p className="section-text">{con?.afterListContent || ""}</p>
                  <p className="section-text">{con?.afterListContent1 || ""}</p>
                </section>
              );
            })}

            <section className="section">
              <h2 className="section-title">
                <span>Author</span>
                <img
                  className="title-underline"
                  src="https://c.animaapp.com/memovagbcMSRxN/img/vector-1.svg"
                  alt=""
                />
              </h2>
              <div className="author-card">
                <img
                  className="author-avatar"
                  src={BlogDetails.author.image}
                  alt={BlogDetails.author.name}
                />
                <div className="author-info">
                  <h3 className="author-name">
                    {BlogDetails.author.name || ""}
                  </h3>
                  <p className="author-title">
                    {BlogDetails.author.role || ""}
                  </p>
                  <p className="author-bio">{BlogDetails.author.bio || ""}</p>
                </div>
              </div>
            </section>
          </main>
        </div>
      </div>
    </div>
  );
};
